export const temporaryTableHeader = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sorter: (a, b) => a.id - b.id,
    fixed: 'left',
  },
  {
    title: 'Name',
    dataIndex: 'field1',
    key: 'field1',
    sorter: (a, b) => a.field1.localeCompare(b.field1),
  },
  {
    title: 'Description',
    dataIndex: 'field2',
    key: 'field2',
    sorter: (a, b) => a.field2.localeCompare(b.field2),
  },
];
